﻿$.fn.dxCtrlContentEnvoiMailingDate = function custom_dxCtrlContentEnvoiMailingDate(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentenvoimailingdate dx-ctrl");
        this.createInstance(new cdxCtrlContentEnvoiMailingDate(this, option));
    }
    return this;
}

window.cdxCtrlContentEnvoiMailingDate = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()
        container.css("height", ((container.innerHeight() == 0) ? "" : container.innerHeight() + 'px'))
        container.empty();
        //plannification

        var $Tr = $("<tr/>").appendTo(container)
        var $Td = $("<td style='width:100%;padding:0 10px;text-align:right;' colspan='2'></td>").appendTo($Tr)
        $A = $("<a href='javascript:void(0)'>Voir la répartition des clicks/vues par Jours/heures</a>").appendTo($Td)
        $A.on("click", function (e) { 
            $("<div/>").appendTo("body").dxCtrlPopupBase({
                position: {
                    my: "right top",
                    at: "right top",
                    of: "body"
                },
                shading: false,
                showMinimize:false,
                hideOnOutsideClick: false,
                width: 700,
                title:"Répartition vues/clicks par jours/heures",
                contentTemplate: function (contentElement) {
                    idTable = option.bddCtrl.getObjet("com_email_envoi").mGetTable().id_table
                    if (option.type == "sms") idTable = option.bddCtrl.getObjet("com_sms_envoi").mGetTable().id_table
                    var dxScroll = $("<div/>").appendTo(contentElement).dxScrollView({}).dxScrollView("instance")
                    $("<div/>").appendTo(dxScroll.content()).dxChartPolarRepartClickVue({
                        bddCtrl: option.bddCtrl,
                        context_grid: "repartjourheurevueclickfromdoc",
                        idTableCom: idTable
                    }).dxChartPolarRepartClickVue("instance")
                }
            }).dxCtrlPopupBase("instance").show()
        })

        if (option.type == "sms" && !parametre.is_generique) {
            var $Tr = $("<tr/>").appendTo(container)
            var $Td = $("<td style='width:100%;padding:0 10px;' colspan='2'></td>").appendTo($Tr)
            $("<div style='margin:5px'/>").appendTo($Td).dxCtrlWarningForm({
                type: "warning",
                html: function () {
                    return "<div style='font-size:90%;'>" +
                        "L’envoi de SMS commerciaux est formellement interdit entre 20h00 et 08h00 les jours calendaires.<br/>" +
                        "Ces restrictions contractuelles avec les opérateurs sont édictées par l’AFMM et ne sont pas spécifiques à notre application.<br/>" +
                        "Le client s'engage à respecter ces obligations sous peine de fortes amendes et de suspension immédiate du compte.<br/>" +
                        "</div>"
                }
            })
        }

        var change = false
        switch (option.type) {
            case "email": case "sms":
                //date envoi
                if (typeof option.showDateDebut == 'undefined' || option.showDateDebut) {
                    var $Tr = $("<tr/>").appendTo(container)
                    var $Td = $("<td style='width:55%;opacity:0.2;padding:0 0 0 10px;text-align:right;padding-right:5px;'>Date début envois</td>").appendTo($Tr)
                    var $Td = $("<td style='white-space:nowrap;width:45%;text-align:right;padding:10px 0;max-width:380px;'/>").appendTo($Tr)
                    $("<div/>").appendTo($Td).dxCtrlDateBox({
                        type: 'datetime',
                        value: option.data.date_debut_envoi,
                        placeholder: "Envoi immédiat",
                        onValueChanged: function (e) {
                            option.data.date_debut_envoi = e.value
                            option.bddCtrl.getObjet(option.data).mSaveChamp("date_debut_envoi", function () { mMajDateFinEnvoi() })
                            if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
                        }
                    })
                }
                //Jour envoi
                var $Tr = $("<tr/>").appendTo(container)
                var $Td = $("<td style='width:55%;opacity:0.2;padding:0 0 0 10px;text-align:right;padding-right:5px;'>Jours envois</td>").appendTo($Tr)
                var $Td = $("<td style='white-space:nowrap;width:45%;text-align:left;padding:10px 0;max-width:380px;'/>").appendTo($Tr)
                //if (option.type == "sms" && (option.data.jour_envoi == null || option.data.jour_envoi.length == 0)) {
                //    change = true
                //    option.data.jour_envoi = "Lu|Ma|Me|Je|Ve"
                //}
                $("<div style='display:inline-block'/>").appendTo($Td).dxCtrlSelectJour({
                    label: "",
                    value: option.data.jour_envoi,
                    onValueChanged: function (e) {
                        option.data.jour_envoi = e.value
                        option.bddCtrl.getObjet(option.data).mSaveChamp("jour_envoi", function () { mMajDateFinEnvoi() })
                        if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
                    }
                }).find(".dx-ctrllstcheckbox").css("padding-top", "0").css("min-height", "0")
                //Jour férie
                var $Tr = $("<tr/>").appendTo(container)
                var $Td = $("<td style='width:55%;opacity:0.2;padding:0 0 0 10px;text-align:right;padding-right:5px;'>Hors jours fériés</td>").appendTo($Tr)
                var $Td = $("<td style='white-space:nowrap;width:45%;text-align:left;padding:10px 0;max-width:380px;'/>").appendTo($Tr)
                //if (option.type == "sms" && (option.data.hors_jours_feries == null || option.data.hors_jours_feries == "0")) {
                //    change = true
                //    option.data.hors_jours_feries = "1"
                //}
                $("<div style='display:inline-block'/>").appendTo($Td).dxCtrlCheckBox({
                    text: "(Actuellement, " + ((option.data.hors_jours_feries == "1") ? "aucun envoi pendant les jours fériés)" : "envoi pendant les jours fériés)"),
                    value: (option.data.hors_jours_feries == "1"),
                    onValueChanged: function (e) {
                        option.data.hors_jours_feries = ((e.value) ? "1" : "0")
                        e.component.option("text", "(Actuellement, " + ((option.data.hors_jours_feries == "1") ? "aucun envoi pendant les jours fériés)" : "envoi pendant les jours fériés)"))
                        option.bddCtrl.getObjet(option.data).mSaveChamp("hors_jours_feries", function () { mMajDateFinEnvoi() })
                        if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
                    }
                })
                //horaire envoi
                var $Tr = $("<tr/>").appendTo(container)
                var $Td = $("<td style='width:55%;opacity:0.2;padding:0 0 0 10px;text-align:right;padding-right:5px;'>Horaire envois</td>").appendTo($Tr)
                var $Td = $("<td style='white-space:nowrap;width:45%;text-align:right;padding:10px 0;max-width:380px;'/>").appendTo($Tr)
                //if (option.type == "sms" && (option.data.horaire_envoi == null || option.data.horaire_envoi.length == 0)) {
                //    change = true
                //    option.data.horaire_envoi = "08:00|20:00"
                //}
                $("<div/>").appendTo($Td).dxCtrlLstTimeBoxInterval({
                    value: option.data.horaire_envoi,
                    intervalMn:30,
                    onValueChanged: function (e) {
                        option.data.horaire_envoi = e.value
                        option.bddCtrl.getObjet(option.data).mSaveChamp("horaire_envoi", function () { mMajDateFinEnvoi() })
                        if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
                    }
                })
                //cadencement email
                var $Tr = $("<tr/>").appendTo(container)
                var $Td = $("<td style='width:55%;opacity:0.2;padding:0 0 0 10px;text-align:right;padding-right:5px;'>Cadencement</td>").appendTo($Tr)
                var $TdCadence = $("<td style='white-space:nowrap;width:45%;text-align:right;padding:10px 0;max-width:380px;'/>").appendTo($Tr)
                var $TableCadencement = $("<table style='width:100%'/>").appendTo($TdCadence)
                var $Tr = $("<tr style='font-family:barlow condensed;'/>").appendTo($TableCadencement)
                var $Td = $("<td style='white-space:nowrap;width:1px;'>envoyer</td>").appendTo($Tr)
                var $Td = $("<td style='width:50%;min-width:120px;'></td>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlNumberBox({
                    min: 0,
                    value: option.data.tempo_envoi_nb_msg,
                    onValueChanged: function (e) {
                        option.data.tempo_envoi_nb_msg = e.value
                        option.bddCtrl.getObjet(option.data).mSaveChamp("tempo_envoi_nb_msg", function () { mMajDateFinEnvoi() })
                        if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
                    }
                })
                var $Td = $("<td style='width:1px;padding:0 5px;white-space:nowrap;'>" + ((option.type == "sms") ? "sms" : "email(s)") + "<br/>tous les</td>").appendTo($Tr)
                var $Td = $("<td style='width:50%;min-width:120px;'></td>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlNumberBox({
                    min: 0,
                    value: option.data.tempo_envoi_sec,
                    onValueChanged: function (e) {
                        option.data.tempo_envoi_sec = e.value
                        option.bddCtrl.getObjet(option.data).mSaveChamp("tempo_envoi_sec", function () { mMajDateFinEnvoi() })
                        if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
                    }
                })
                var $Td = $("<td style='white-space:nowrap;width:1px;'>sec.</td>").appendTo($Tr)
                $("<div style='font-family:barlow condensed;font-style:italic;opacity:0.3;white-space:normal;text-align:center;'>Vos envois sont déjà cadencés pour un envoi optimal. Toutefois, pour augmenter votre délivrabilité, vous pouvez augmenter le cadencement si vous le désirez.</div>").appendTo($TdCadence)

                var $Tr = $("<tr style='font-weight:bold;'/>").appendTo(container)
                var $Td = $("<td style='width:55%;opacity:0.2;padding:0 0 0 10px;text-align:right;padding-right:5px;'>Date estimée<br/>de fin des envois</td>").appendTo($Tr)
                var $TdDateFinEnvoi = $("<td style='white-space:nowrap;width:45%;text-align:right;font-size:160%;line-height:0.7;padding:20px 10px 20px 0;max-width:380px;'></td>").appendTo($Tr)

                if (change) {
                    change = false
                    option.bddCtrl.getObjet(option.data).mSave(function (data) {
                        mMajDateFinEnvoi()
                    })
                } else { mMajDateFinEnvoi() }

                function mMajDateFinEnvoi() {
                    $TdDateFinEnvoi.text("Calcul...")
                    $TdDateFinEnvoi.addClass("blink")
                    option.bddCtrl.mAjaxCall({ command: "getdatefinenvoiestime", id_table_com: option.bddCtrl.getObjet(option.data).mGetTable().id_table, id_com: option.bddCtrl.getObjet(option.data).cle() }, function (data) {
                        if (data.date_fin_envoi.getFullYear() == 1901) { $TdDateFinEnvoi.text("---") }
                        else {
                            $TdDateFinEnvoi.html(data.date_fin_envoi.toDateIlya() + "<br/><span style='font-size:60%;'>" + data.date_fin_envoi.toFrenchDateTime() + "</span>")
                            if (option.type == "sms" && option.data.ajout_stop == "1") {
                                $("<br/>").appendTo($TdDateFinEnvoi)
                                $("<div style='color:orange;font-size: 50%;font-weight: normal;white-space: normal;line-height: 1.2;padding-top: 5px;'>Votre SMS étant de nature commerciale (vous avez demandé l’ajout de la mention <b>STOP</b> pour la désinscription), il ne pourra être envoyé que du lundi au samedi, entre 8h00 et 20h00, hors jours fériés. Si ces conditions sont respectées, votre paramétrage des périodes d’envoi sera pris en compte.</div>").appendTo($TdDateFinEnvoi)
                            }
                        }
                        $TdDateFinEnvoi.removeClass("blink")
                    })
                }
                break;
            default: break;
        }

        container.css("height", "")
    }

    this.element = function () { return container }

    mConstruit();
}